import { faRotateLeft } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { Delete } from "@mui/icons-material";
import {
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Input,
  Tooltip,
  Typography,
} from "@mui/material";
import CustomSearchBar from "components/CustomSearchBar";
import CustomTable from "components/CustomTable";
import { selectCurrentRoles } from "features/auth/authSlice";
import { useGetmasterRolesQuery } from "features/masterdata/MasterApiSlice";
import useDebouncedValue from "hooks/useDebouncedValue";
import { useEffect, useState } from "react";
import { Button, Modal, Spinner } from "react-bootstrap";
import { useSelector } from "react-redux";
import { Link, useParams } from "react-router-dom";
import Select from "react-select";
import { toast } from "react-toastify";
import { Card, CardBody, Col, Row } from "reactstrap";
import * as XLSX from "xlsx";
import AddEmployee from "./AddEmployee";
import AddEmployeeHCL from "./AddEmployeeHCL";
import {
  useDeleteUserMutation,
  useGetAllEmployeeQuery,
  useGetAllPospQuery,
  useGetRoleListDataQuery,
} from "./UserManagementApiSlice";
import CustomTextField from "components/CustomTextField";

const EmployeesList = (checking) => {
  const { id } = useParams();
  const orgId = id ? id : "";
  const [users, setUsers] = useState([]);
  const [addEmployee, setAddEmployee] = useState(false);
  const [searchKey, setSearchKey] = useState("");
  const [pagination, setPagination] = useState({ page: 1, pageCount: 0 });
  const [activeCard, setActiveCard] = useState("Employees");
  const [rolesList, setCheckRolesList] = useState([]);
  const { data: getRoles } = useGetmasterRolesQuery();
  const [roles, setRoles] = useState("");
  const [loading, setLoading] = useState(false);
  const debouncedSearch = useDebouncedValue(searchKey);
  const [selectedEmployeeId, setSelectedEmployeeId] = useState("");
  const [opendelteEmployee, setOpenDeleteEmployeeModal] = useState(false);
  const [selectedEmployee, setSelectedEmployee] = useState("");
  const [input, setInput] = useState("");
  const [isMatch, setIsMatch] = useState(null);

  let stateId = "";
  let districtId = "";
  var EmployeeApi = useGetAllEmployeeQuery(
    {
      orgId,
      pagination,
      searchKey: debouncedSearch || "",
      stateId,
      districtId,
    },
    { skip: checking?.checking === "POSP" }
  );
  const [deleteUser] = useDeleteUserMutation();

  var PospApi = useGetAllPospQuery(
    { pagination, searchKey: debouncedSearch || "" },
    { skip: checking?.checking !== "POSP" }
  );
  const { data: RoleDropdownListData } = useGetRoleListDataQuery(
    { pagination: pagination, roles: roles },
    { skip: !roles }
  );

  const RolesFromToken = useSelector(selectCurrentRoles);
  const RoleAcessParams = RolesFromToken?.realm_access?.roles;
  const [PopUpAddEmployee, setPopUpAddEmployee] = useState(false);
  const { data: data, isLoading, isFetching, refetch } =
    checking?.checking === "POSP" ? PospApi : EmployeeApi;

  useEffect(() => {
    refetch();
  }, [addEmployee]);
  const hasPermission =
    RolesFromToken?.groups?.includes("admin") ||
    RolesFromToken?.groups?.includes("HR") ||
    RolesFromToken?.groups?.includes("State Head") ||
    RolesFromToken?.groups?.includes("Cluster Head") ||
    RolesFromToken?.groups?.includes("developer");

  const handleDeleteModal = (e, cellvalues) => {
    setSelectedEmployeeId(e);
    setSelectedEmployee(cellvalues?.row?.phone_number);
    setOpenDeleteEmployeeModal(true);
  };

  const handleCheckPhoneNumber = (e) => {
    const value = e.target.value.replace(/\D/g, "");
    setInput(value);

    if (value.length === 10) {
      setIsMatch(value === selectedEmployee);
    } else {
      setIsMatch(null);
    }
  };

  const handleDeleteEmployee = (e) => {
    e.preventDefault();
    deleteUser({ id: selectedEmployeeId })
      .unwrap()
      .then((data) => {
        toast.success("Employee Deleted Successfully");
        setOpenDeleteEmployeeModal(false);
        refetch();
      })
      .catch((e) => {
        toast.error("Something went wrong");
      });
  };

  const columns = [
    {
      field: "profile_pic",
      headerName: "Name",
      width: 250,
      renderCell: (params) => (
        <>
          <img
            src={params.value}
            width="35px"
            height="35px"
            alt=""
            className="rounded-circle"
          />{" "}
          <span className="mx-2">{params.row.full_name}</span>
        </>
      ),
    },

    // { field: "full_name", headerName: "Name", width: 220 },
    { field: "phone_number", headerName: "Phone Number", width: 160 },

    { field: "employee_code", headerName: "Employee Code", width: 160 },
    { field: "designation", headerName: "Designation", width: 200 },
    { field: "department", headerName: "Department", width: 150 },
    { field: "DOB", headerName: "DOB", width: 120 },

    ...(!RoleAcessParams.includes("FPO")
      ? [
          {
            field: "assigned_zone",
            headerName: "Assigned Zone",
            width: 150,
            headerAlign: "center",
            align: "center",
          },
        ]
      : []),
    {
      field: "action",
      headerName: "Action",
      width: 100,
      renderCell: (cellvalues) => {
        return (
          <>
            {hasPermission &&
            !RoleAcessParams.includes("HCL") &&
            !RoleAcessParams.includes("UP_GOV") ? (
              <Link to={`/user-management/${cellvalues.id}`}>
                <span class="mdi mdi-eye text-orange mx-3"></span>
              </Link>
            ) : hasPermission &&
              (RoleAcessParams.includes("HCL") ||
                RoleAcessParams.includes("UP_GOV")) ? (
              <Link to={`/detailView/employee/${cellvalues.id}`}>
                <span class="mdi mdi-eye text-orange mx-3"></span>
              </Link>
            ) : (
              <Tooltip title="You dont have Permission.">
                <span class="mdi mdi-eye text-orange  mx-3"></span>
              </Tooltip>
            )}

            {RoleAcessParams.includes("developer") && (
              <Tooltip title="Delete">
                {" "}
                <Delete
                  className="mr-2 text-danger cursor mb-1"
                  sx={{ fontSize: "16px" }}
                  onClick={() => handleDeleteModal(cellvalues?.id, cellvalues)}
                />
              </Tooltip>
            )}
          </>
        );
      },
    },
  ];

  useEffect(() => {
    const dataFromApi = data?.data?.results ? data?.data?.results : [];
    const paginationFromApi = data?.data?.pages
      ? { page: data?.data?.current_page, pageCount: data?.data?.pages }
      : pagination;
    setUsers(dataFromApi);
    setPagination(paginationFromApi);
    if (roles !== "" && RoleDropdownListData) {
      const paginationData = RoleDropdownListData?.data?.pages
        ? {
            page: RoleDropdownListData?.data?.current_page,
            pageCount: RoleDropdownListData?.data?.pages,
          }
        : pagination;
      setUsers(RoleDropdownListData?.data?.results);
      setPagination(paginationData);
    }
  }, [data, RoleDropdownListData]);

  useEffect(() => {
    if (getRoles !== undefined) {
      setCheckRolesList(getRoles?.data);
    }
  }, [getRoles]);

  const tableData = {
    rows: users,
    columns: columns,
    paginationState: [pagination, setPagination],
    isLoading: isLoading || isFetching,
    checkboxShowFalse: true,
  };

  const handleCancel = (value) => {
    setAddEmployee(value);
  };

  const handleChangeSearch = (message) => {
    setSearchKey(message);
    setRoles("");
  };

  const handleAddEmployee = () => {
    setPopUpAddEmployee(true);
  };
  const handleRolesOptions = () => {
    let responseAgentArray = [];
    const filteredList = rolesList.filter((item) => {
      if (RolesFromToken?.groups?.includes("admin")) {
        return item.name !== "admin";
      }
      if (RolesFromToken?.groups?.includes("developer")) {
        return true;
      }
      if (RolesFromToken?.groups?.includes("HR")) {
        return [
          "State Head",
          "District Head",
          "Cluster Head",
          "Maker",
          "Checker",
          "FLE",
        ].includes(item.name);
      }
      if (RolesFromToken?.groups?.includes("Banking Admin")) {
        return [
          "State Head",
          "District Head",
          "Cluster Head",
          "Maker",
          "Checker",
          "FLE",
        ].includes(item.name);
      }
      if (RolesFromToken?.groups?.includes("State Head")) {
        return [
          "District Head",
          "Cluster Head",
          "Maker",
          "Checker",
          "FLE",
        ].includes(item.name);
      }
      if (
        RolesFromToken?.groups?.includes("District Head") ||
        RolesFromToken?.groups?.includes("Cluster Head")
      ) {
        return ["FLE"].includes(item.name);
      }
      if (RolesFromToken?.groups?.includes("CRM Admin")) {
        return ["CRM User"].includes(item.name);
      }

      if (RolesFromToken?.groups?.includes("Maker")) {
        return false; // Maker cannot see roles
      }
      if (RolesFromToken?.groups?.includes("Checker")) {
        return false; // Checker cannot see roles
      }
      if (RolesFromToken?.groups?.includes("CRM User")) {
        return false; // CRM User cannot see or edit roles
      }
      return false; // Default case: Show no roles
    });

    filteredList?.map((item) => {
      responseAgentArray.push({
        value: item.id,
        label: item.name,
        ConditionName: "Roles",
      });
    });

    return responseAgentArray;
  };
  const handleRole = (event) => {
    setRoles(event?.label);
    // setRolesId(event?.value);
    setSearchKey("");
  };
  const customStyles = {
    control: (provided) => ({
      ...provided,
      minHeight: "38px",
      height: "35px",
      padding: "0px",
      fontSize: "14px",
      color: "#aeaeae",
      zIndex: 1000,
      border: "1px solid #aeaeae",
    }),
  };
  const downloadExcel = () => {
    setLoading(true);
    const headers = [
      "Name",
      "Phone Number",
      "Employee Code",
      "Designation",
      "Department",
      "DOB",
      "Assigned Zone",
    ];

    const rows =
      roles !== ""
        ? rolesList
        : users.map((user) => {
            const baseRow = {
              Name: user.full_name || "",
              Phone: user.phone_number || "",
              EmployeeCode: user.employee_code || "",
              Designation: user.designation || "",
              Department: user.department || "",
              DOB: user.DOB || "",
              AssignedZone: user.assigned_zone || "",
            };
            return baseRow;
          });
    const worksheet = XLSX.utils.json_to_sheet(rows);
    const workbook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(workbook, worksheet, "Leads");
    setLoading(false);
    XLSX.writeFile(workbook, "Employees.xlsx");
  };
  const ReloadApplication = () => {
    // setLoaderMain(true);
    setTimeout(() => {
      refetch();
      // setLoaderMain(false);
    }, 1500);
  };
  return (
    <div>
      <div>
        {" "}
        {/* {addEmployee ? (
          <>
            <div className="d-flex justify-content-end">
              <Button
                className="bg-transparent text-black fs-6"
                style={{ border: "1px solid black", marginTop: RoleAcessParams.includes("HCL")?"":"-2%",marginRight: RoleAcessParams.includes("HCL")?"32px":"" }}
                size="sm"
                onClick={() => handleCancel(false)}
              >
                Cancel <span class="mdi mdi-window-close"></span>
              </Button>
            </div>
            
            {RoleAcessParams.includes("HCL")? <AddEmployeeHCL
              sendSubmitStatus={setAddEmployee}
              isCreateComponent={true}
              cancelbutton={handleCancel}
              showNavHcl={true}
            />
            :<AddEmployee
            sendSubmitStatus={setAddEmployee}
            isCreateComponent={true}
            cancelbutton={handleCancel}
            showNavHcl={true}
          />}
            
          </>
        ) : */}
        {activeCard === "Employees" ? (
          <Card className="">
            <CardBody style={{ padding: "1.5%" }}>
              <Row className="d-flex align-items-center mt-1 mt-lg-0 mt-md-0">
                <Col
                  xs="10"
                  sm="8"
                  md="2"
                  lg="2"
                  className="d-flex justify-content-start"
                >
                  <CustomSearchBar sendSearchFunction={handleChangeSearch} />
                </Col>
                <Col lg="2" className="position-relative">
                  <Select
                    name="roles"
                    // placeholder={roles === "" ? "Select Roles" : roles}
                    placeholder="Select Roles"
                    value={roles ? { label: roles, value: roles } : null}
                    options={handleRolesOptions()}
                    onChange={handleRole}
                    styles={customStyles}
                  />
                  {roles && (
                    <span
                      className="clear-icon"
                      onClick={() => {
                        setRoles("");
                        refetch();
                      }}
                      style={{
                        position: "absolute",
                        top: "55%",
                        right: "63px",
                        transform: "translateY(-50%)",
                        cursor: "pointer",
                        color: "gray",
                        fontSize: "12px",
                        zIndex: 1000,
                      }}
                    >
                      ✕
                    </span>
                  )}
                </Col>
                <Col md="2">
                  Total :
                  <span className="text-success">
                    &nbsp;{" "}
                    {roles !== ""
                      ? RoleDropdownListData?.data?.total
                      : data?.data?.total}
                  </span>
                </Col>
                <Col
                  xs="2"
                  sm="4"
                  md="4"
                  lg="4"
                  className="d-flex justify-content-end offset-md-2"
                >
                  {checking?.checking === "POSP" ? (
                    ""
                  ) : hasPermission ? (
                    <>
                      <Button
                        id="AddLeads"
                        className="buttonOrangeDefaultColor"
                        size="sm"
                        onClick={handleAddEmployee}
                      >
                        Add Employee&nbsp;
                        <i className="mdi mdi-account-plus custom-btn-fs fs-6"></i>
                      </Button>
                      <Button
                        id="AddLeads"
                        className="buttonGreenDefaultColor"
                        size="sm"
                        onClick={downloadExcel}
                      >
                        Download&nbsp;
                        <i className="mdi mdi-account-arrow-right custom-btn-fs fs-6"></i>
                        &nbsp;{loading ? <Spinner size="sm" /> : ""}
                      </Button>
                      <Button
                        className="bg-transparent text-black fs-6  reloadButton float-end"
                        size="sm"
                        onClick={ReloadApplication}
                      >
                        <FontAwesomeIcon icon={faRotateLeft} />
                      </Button>
                    </>
                  ) : (
                    <Tooltip title="You dont have Permission.">
                      {/* <Button
                        id="AddLeads"
                        className="fs-6 d-flex"
                        disabled
                        size="sm"
                      >
                        <span className="d-lg-block d-none">Add Employee</span>
                        <i className="mdi mdi-account-plus fs-6 mx-1"></i>
                      </Button> */}
                      <Button
                        id="AddLeads"
                        className="buttonOrangeDefaultColor"
                        size="sm"
                        disabled
                      >
                        Add Lead&nbsp;
                        <i className="mdi mdi-account-plus custom-btn-fs fs-6"></i>
                      </Button>
                    </Tooltip>
                  )}
                </Col>
              </Row>

              {/* <Row className="d-flex align-items-center">
            <Col xs="10" md="6" lg="5" className="d-flex justify-content-start">
              <CustomSearchBar sendSearchFunction={handleChangeSearch} />
            </Col>
      
            <Col xs="2" md="6" lg="6" className="d-flex justify-content-end">
              {checking?.checking === "POSP" ? (
                ""
              ) : (
                <Button
                  id="AddLeads"
                  className="me-2 fs-6"
                  onClick={handleAddEmployee}
                >
                 <span className='d-lg-block d-none'>  Add Employee </span>
                  <i className="mdi mdi-account-plus custom-btn-fs mx-1 fs6"></i>
                </Button>
              )}
            </Col> 
          </Row> */}

              {/* Table Section */}
              <CustomTable
                rows={tableData.rows}
                columns={tableData.columns}
                paginationState={tableData.paginationState}
                loading={tableData.isLoading}
                checkboxShowFalse={tableData.checkboxShowFalse}
              />
            </CardBody>
          </Card>
        ) : (
          ""
        )}
        <Modal
          show={PopUpAddEmployee}
          onHide={() => setPopUpAddEmployee(false)}
          size="xl"
        >
          <Modal.Header closeButton>
            <Modal.Title style={{ color: "" }} className="fw-bold">
              Add Employees
            </Modal.Title>
          </Modal.Header>
          <Modal.Body className="p-2">
            <div className="">
              {RoleAcessParams.includes("HCL") ||
              RoleAcessParams.includes("UP_GOV") ? (
                <AddEmployeeHCL
                  sendSubmitStatus={setAddEmployee}
                  isCreateComponent={true}
                  cancelbutton={handleCancel}
                  setPopUpAddEmployee={setPopUpAddEmployee}
                  refetch={refetch}
                />
              ) : (
                <AddEmployee
                  sendSubmitStatus={setAddEmployee}
                  isCreateComponent={true}
                  cancelbutton={handleCancel}
                  setPopUpAddEmployee={setPopUpAddEmployee}
                  refetch={refetch}
                />
              )}
            </div>
          </Modal.Body>
          <Modal.Footer>
            {/* <button
              className="btn btn-danger waves-effect me-2"
              onClick={()=>setPopUpAddEmployee(false)}
            >
              Cancel
            </button> */}
          </Modal.Footer>
        </Modal>
        {/* Delete Employee Model  */}
        <Dialog
          open={opendelteEmployee}
          onClose={() => setOpenDeleteEmployeeModal(false)}
          maxWidth="xs"
          fullWidth
        >
          <DialogTitle>Delete Employee</DialogTitle>
          <DialogContent>
            <Typography>
              To confirm deletion, Enter the employee's Phone number.
            </Typography>

            <div className="col-lg-7">
              <CustomTextField
                name=""
                maxLength={10}
                defaultValue={input}
                onChange={(e) => handleCheckPhoneNumber(e)}
                placeholder="Enter phone number"
              />
              {isMatch === true && (
                <small className="text-success  mt-1">
                  Phone number matches!
                </small>
              )}
              {isMatch === false && input.length === 10 && (
                <small className="text-danger  mt-1">
                  Phone number does not match.
                </small>
              )}
            </div>
          </DialogContent>
          <DialogActions>
            <Button
              onClick={() => setOpenDeleteEmployeeModal(false)}
              color="primary"
              size="sm"
            >
              Cancel
            </Button>
            <Button
              className="btn delete-btn"
              onClick={(e) => handleDeleteEmployee(e)}
              style={{ background: "#fe5555", forcedColorAdjust: "none" }}
              size="sm"
              disabled={!isMatch}
            >
              Delete
            </Button>
          </DialogActions>
        </Dialog>
      </div>
    </div>
  );
};

export default EmployeesList;
